const WishlistPage = () => {
    return (
        <div>
            Orders Page
        </div>
    )
}

export default WishlistPage;